// src/contexts/UserContext.js
import React, { createContext, useState, useEffect } from "react";
import { getBaseUrl } from "../utils";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const baseUrl = getBaseUrl();
  const token = localStorage.getItem("userToken");

  const [userProfile, setUserProfile] = useState({
    name: "",
    profile_img: "", // This holds your image path
  });
  const [profileData, setProfileData] = useState(null);

  // 🔹 Subscription State
  const [subscription, setSubscription] = useState(null);
  const [loadingSubscription, setLoadingSubscription] = useState(true);

  // 🔹 Fetch Current Subscription
  const fetchSubscription = async () => {
    try {

      const response = await fetch(`${baseUrl}user_api/subscriptions/current`, {
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });

      const data = await response.json();

      if (data.status) {
        setSubscription(data.data);
      }

    } catch (error) {
      console.error("Subscription fetch error:", error);
    } finally {
      setLoadingSubscription(false);
    }
  };

  // 🔹 Load subscription when user logs in
  useEffect(() => {
    if (token) {
      fetchSubscription();
    }
  }, [token]);
  
  return (
    <UserContext.Provider value={{
      userProfile,
      setUserProfile,
      profileData,
      setProfileData,
      // subscription data
      subscription,
      loadingSubscription,
      fetchSubscription
    }}>
      {children}
    </UserContext.Provider>
  );
};
